<script setup>
import { ref, onMounted } from 'vue'
import TarjetasSimples from '@/components/ui/TarjetasSimples.vue'

const cdnArchivos = process.env.VUE_APP_CDN_ARCHIVOS
const url = `${cdnArchivos}/descargas/tarjetas_descarga.json`

const datos_tarjetas_administrativas = ref([])
const datos_tarjetas_politica_publica = ref([])

const cargarDatos = async () => {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('Error al cargar archivo')
    }

    const los_datos = await response.json()
    datos_tarjetas_administrativas.value = los_datos.slice(0, 8)
    datos_tarjetas_politica_publica.value = los_datos.slice(8)
  } catch (error) {
    console.error(error)
  }
}

onMounted(cargarDatos)
</script>

<template>
  <div class="contenedor ancho-fijo m-y-maximo">
    <div class="contenedor ancho-lectura">
      <h1 class="titulo-pagina texto-centrado">Descargas</h1>
      <p>
        Para abonar a lo que se estipula en la
        <SisdaiEnlaceExterno
          :enlace="'https://www.diputados.gob.mx/LeyesBiblio/pdf/LFTAIP.pdf'"
          :texto="'Ley Federal de Transparencia y Acceso a la Información Pública Gubernamental'"
        />
        sobre el acceso a la información como un derecho humano, en esta sección
        se encuentran todas las descargas que se alojan en la página de inicio
        para que puedas explorarlas y cotejar las comparaciones.
      </p>
      <br />
    </div>
    <div class="flex">
      <div class="columna-8">
        <div class="tarjeta tarjeta-horizontal compilado">
          <img
            class="tarjeta-imagen"
            :src="`${cdnArchivos}/descargas/compilado-descargas.png`"
            alt=""
          />
          <div class="tarjeta-cuerpo">
            <p class="tarjeta-titulo">Compilado de descargas</p>
            <p>Todas las descargas en un solo archivo.</p>
          </div>
          <div class="tarjeta-pie">
            <a
              class="boton-primario boton-chico"
              :href="`${cdnArchivos}/descargas/compilado_de_descargas.zip`"
            >
              Descargar ZIP
            </a>
          </div>
        </div>
      </div>
      <div class="columna-8">
        <div class="tarjeta tarjeta-horizontal repo">
          <img
            class="tarjeta-imagen"
            :src="`${cdnArchivos}/descargas/repositorio.png`"
            alt=""
          />
          <div class="tarjeta-cuerpo">
            <p class="tarjeta-titulo">Repositorio</p>
            <p>Conoce el Repositorio Institucional del Conahcyt.</p>
          </div>
          <div class="tarjeta-pie">
            <a
              class="boton-primario boton-chico"
              href="https://conahcyt.repositorioinstitucional.mx/jspui/handle/1000/6"
              target="_blank"
            >
              Ir a repositorio
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="contenedor ancho-lectura">
      <h2 class="titulo-sección texto-centrado">
        Transformación administrativa del Consejo
      </h2>
    </div>

    <div class="flex">
      <div
        class="columna-8 m-b-3"
        v-for="(dato, i) in datos_tarjetas_administrativas"
        :key="i"
      >
        <TarjetasSimples
          :enlace_logo="cdnArchivos + '/descargas/' + dato.tipo_logo + '.svg'"
          :titulo="dato.titulo_tarjeta"
          :parrafo="dato.parrafo_descargas"
          :nombre_descarga="dato.nombre_descarga"
          :enlace_descarga="dato.enlace_descarga"
        ></TarjetasSimples>
      </div>
    </div>
    <div class="contenedor ancho-lectura">
      <h2 class="titulo-sección texto-centrado">
        Transformación de la política pública de HCTI
      </h2>
    </div>
    <div class="flex">
      <div
        class="columna-8 m-b-3"
        v-for="(dato, i) in datos_tarjetas_politica_publica"
        :key="i"
      >
        <TarjetasSimples
          :enlace_logo="cdnArchivos + '/descargas/' + dato.tipo_logo + '.svg'"
          :titulo="dato.titulo_tarjeta"
          :parrafo="dato.parrafo_descargas"
          :nombre_descarga="dato.nombre_descarga"
          :enlace_descarga="dato.enlace_descarga"
        ></TarjetasSimples>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
div.tarjeta.tarjeta-horizontal {
  &.compilado,
  &.repo {
    min-height: 213px;
  }
}
</style>
